import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import locationIcon from '../../../../assets/img/location-icon.svg'
import calendarIcon from '../../../../assets/img/calendar-icon.svg'
import { UserIcon, ClockIcon, PlayIcon } from '../../../../assets/svg'
import { ORGANIZER_EVENT_STATUSES } from '../../../../assets/const'


const STATUS_META = {
  [ORGANIZER_EVENT_STATUSES.ACCEPTING]: {
    label: 'Приём заявок',
    bg: '#FEF3C7',
    color: '#B45309',
    border: '#FBBF24',
    Icon: ClockIcon,
  },
  [ORGANIZER_EVENT_STATUSES.IN_PROGRESS]: {
    label: 'Проводится',
    bg: '#EDE9FE',
    color: '#7C3AED',
    border: '#E5E7EB',
    Icon: PlayIcon,
  },
}

const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status]
  if (!meta) return null
  const { label, bg, color, Icon } = meta
  return (
    <span
      className="flex items-center gap-[0.375rem] whitespace-nowrap rounded-[50px] px-[0.75rem] sm:px-[0.875rem] py-[0.375rem] text-[0.812rem] sm:text-[0.875rem] font-medium"
      style={{ backgroundColor: bg, color }}
    >
      <Icon color={color} />
      {label}
    </span>
  )
}

const EventCard = ({ id, title, location, dates, commission, status }) => {
  const meta = STATUS_META[status]
  const borderColor = meta?.border || '#E5E7EB'

  return (
    <NavLink
      to={`/organizer/active/${id}/details`}
      className="block no-underline text-inherit"
    >
      <article
        className="flex w-full flex-col gap-[1rem] sm:gap-[1.25rem] rounded-[20px] border-[1px] border-solid bg-white p-[1.25rem] sm:p-[1.5rem] lg:p-[1.75rem]"
        style={{ borderColor }}
      >
      <div className="flex flex-col gap-[0.75rem] sm:flex-row sm:items-start sm:justify-between sm:gap-[1.25rem]">
        <div className="flex flex-col gap-[0.5rem] sm:gap-[0.625rem] min-w-0">
          <h3 className="m-0 text-[1.125rem] sm:text-[1.25rem] font-semibold leading-[1.4] text-[#111827] break-words">
            {title}
          </h3>
          <div className="flex flex-col gap-[0.312rem] text-[0.875rem] sm:text-[0.938rem] text-[#6b7280]">
            <div className="flex items-center gap-[0.5rem]">
              <img src={locationIcon} alt="" className="h-[1.125rem] w-[1.125rem] shrink-0" />
              <span className="break-words">{location}</span>
            </div>
            <div className="flex items-center gap-[0.5rem]">
              <img src={calendarIcon} alt="" className="h-[1.125rem] w-[1.125rem] shrink-0" />
              <span className="break-words">{dates}</span>
            </div>
          </div>
        </div>
        <div className="self-start sm:self-auto">
          <StatusBadge status={status} />
        </div>
      </div>

      <div className="flex flex-col gap-[0.625rem]">
        <div className="flex items-center gap-[0.5rem] text-[0.812rem] sm:text-[0.875rem] text-[#9ca3af]">
          <UserIcon />
          <span>Комиссия</span>
        </div>
        <div className="flex flex-wrap gap-[0.5rem]">
          {commission.map((name, i) => (
            <span
              key={i}
              className="rounded-[50px] border border-solid border-[#e5e7eb] bg-white px-[0.875rem] sm:px-[1rem] py-[0.375rem] text-[0.812rem] sm:text-[0.875rem] text-[#475569] break-words"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
      </article>
    </NavLink>
  )
}

EventCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  dates: PropTypes.string.isRequired,
  commission: PropTypes.arrayOf(PropTypes.string).isRequired,
  status: PropTypes.oneOf(Object.values(ORGANIZER_EVENT_STATUSES)).isRequired,
}

export default EventCard
